export default __webpack_public_path__ + "static/media/vector.db054371.svg";